import {
    generatePath,
    useNavigate,
} from 'react-router-dom'
import {
    useCallback,
} from 'react'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    APPS,
    NavigateFunctionArgs,
} from '../SkyNetRoutes.types'

export default function useSkyNetNavigate() {
    const navigate = useNavigate()

    return useCallback((
        path: string[],
        navigateParams?: NavigateFunctionArgs,
    ) => {
        navigate(
            generatePath([
                CommonRoutes.Slash,
                APPS,
                ...path,
            ].filter(Boolean).join('/'),
            navigateParams?.params),
            navigateParams?.options,
        )
    }, [navigate])
}
